import { create } from 'zustand'

const useProductStore =create((set) => ({
    pickedProduct: '',
    pickedProductDisplayName: '',
    setProduct: (product) => set({pickedProduct : product}),
    setProductDisplayName: (product) => set({pickedProductDisplayName : product})
  }));

export default useProductStore